// @flow

import React from "react";
import { connect } from "react-redux";

import { Flex, Button } from "@src/common";
import { updateStep, clearEverything } from "@src/actions";
import { downloadPdf, printPdf } from "@src/pdf/documentTemplate";

import NavigationWrapper from "./components";

class NavigationButtons extends React.Component {
  state = {
    downloaded: false // Keep track of pdf download
  };

  startNewAssessment = () => {
    // this.props.history.replace("/");
    this.props.clearEverything();
  };

  getSteps = () => [
    this.props.sections.riskindicators,
    this.props.sections.riskfatings,
    this.props.sections.contributingfactors
  ];

  getStep = stepIdx => this.getSteps()[stepIdx];

  getSubSteps = stepIdx => {
    const step = this.getStep(stepIdx);
    return step ? step.subsections || [] : [];
  };

  doStep = direction => {
    const newStepMeta = {};
    const currentStepIdx = this.props.stepsMeta.activeStep;
    const step = this.getStep(currentStepIdx);
    const subSteps = this.getSubSteps(currentStepIdx);

    let nextStepIdx;
    let nextSubStepIdx;

    // Determine which direction we're moving
    switch (direction) {
      case "next":
        nextStepIdx = currentStepIdx + 1;
        nextSubStepIdx = subSteps.length
          ? this.props.stepsMeta.activeSubStep + 1
          : 0;
        break;
      case "prev":
        nextStepIdx = currentStepIdx - 1;
        nextSubStepIdx = subSteps.length
          ? this.props.stepsMeta.activeSubStep - 1
          : 0;
        break;
      default:
      // do nothing
    }

    // Determine if we should be moving between substeps or parent steps
    if (step && subSteps[nextSubStepIdx]) {
      newStepMeta.activeStep = currentStepIdx;
      newStepMeta.activeSubStep = nextSubStepIdx;
    } else {
      newStepMeta.activeStep = nextStepIdx;
      newStepMeta.activeSubStep = 0;
    }

    this.props.updateStep(newStepMeta);
  };

  getNextText = (stepIdx, showComplete, hasSubSteps, lastSubStep) => {
    const availableText = {
      default: "Next",
      complete: "Complete",
      0: "Continue to Risk Rating",
      1: "Continue to Contributing Factors"
    };

    let outText;

    if (hasSubSteps && !lastSubStep) {
      outText = availableText.default;
    } else {
      outText = availableText[stepIdx];
    }

    if (showComplete) {
      outText = availableText.complete;
    }

    return outText;
  };

  getButtons = () => {
    const currentParentStep = this.props.stepsMeta.activeStep;
    const isLastParentStep =
      this.props.stepsMeta.activeStep >= this.props.totalParentSteps - 1;
    const subSteps = this.getSubSteps(currentParentStep);
    const hasSubSteps = subSteps.length > 0;
    const currentSubStep = this.props.stepsMeta.activeSubStep;
    const isLastSubStep = hasSubSteps && currentSubStep >= subSteps.length - 1
      ? true
      : false;

    // First and last step aware of substeps
    const isFirstStep = currentParentStep <= 0;

    const showComplete =
      isFirstStep && isLastSubStep && !this.props.showContinueOnStageA;

    const nextText = this.getNextText(
      currentParentStep,
      showComplete,
      hasSubSteps,
      isLastSubStep
    );

    // Default we only support next, other buttons added contextually
    let buttons = [
      <Button key="0" medium marginH="2" onClick={() => this.doStep("next")}>
        {nextText}
      </Button>
    ];

    if (isFirstStep && !isLastSubStep) {
      buttons = [
        <Button key="0" medium marginH="2" onClick={() => this.doStep("next")}>
          {nextText}
        </Button>
      ];
    } else if (isFirstStep && isLastSubStep) {
      buttons = [
        <Button
          key="0"
          medium
          marginH="2"
          secondary
          onClick={() => this.doStep("prev")}
        >
          Previous
        </Button>
      ];

      if (showComplete) {
        buttons.push(
          <Button
            key="1"
            medium
            marginH="2"
            onClick={() => this.props.showDialog()}
            disabled={this.props.disabledComplete}
          >
            {nextText}
          </Button>
        );
      } else {
        buttons.push(
          <Button
            key="1"
            medium
            marginH="2"
            onClick={() => this.doStep("next")}
          >
            {nextText}
          </Button>
        );
      }
    }

    if (isLastParentStep && currentSubStep > 0 && !isLastSubStep) {
      buttons = [
        <Button
          key="1"
          medium
          marginH="2"
          secondary
          onClick={() => this.doStep("prev")}
        >
          Previous
        </Button>,
        <Button key="0" medium marginH="2" onClick={() => this.doStep("next")}>
          {nextText}
        </Button>
      ];
    } else if (isLastParentStep && isLastSubStep) {
      buttons = [];

      if (this.state.downloaded) {
        buttons = [
          <Button
            key="0"
            medium
            marginH="2"
            secondary
            onClick={() => {
              this.setState({ downloaded: true });
              downloadPdf(this.props.appState);
            }}
          >
            Download PDF
          </Button>,
          <Button
            key="1"
            marginH="2"
            medium
            onClick={() => this.startNewAssessment()}
          >
            New Assessment
          </Button>
        ];
      } else {
        buttons = [
          <Button
            key="0"
            medium
            marginH="2"
            secondary
            onClick={() => this.doStep("prev")}
          >
            Previous
          </Button>,
          <Button
            key="1"
            medium
            marginH="2"
            secondary
            onClick={() => printPdf(this.props.appState)}
          >
            Print
          </Button>,
          <Button
            key="2"
            medium
            marginH="2"
            onClick={() => {
              this.setState({ downloaded: true });
              downloadPdf(this.props.appState);
            }}
          >
            Download PDF
          </Button>
        ];
      }
    }

    return buttons;
  };

  render() {
    return (
      <NavigationWrapper>
        <Flex justifyContent="flex-end">{this.getButtons()}</Flex>
      </NavigationWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateStep: args => dispatch(updateStep(args)),
    clearEverything: () => dispatch(clearEverything())
  };
}

function mapStateToProps(store) {
  return {
    stepsMeta: store.sideBar.stepsMeta,
    totalParentSteps: store.sideBar.stepsMeta.totalParentSteps,
    sections: store.app.sections,
    appState: store.app
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationButtons);



// WEBPACK FOOTER //
// ./src/containers/Assessment/Navigation/index.js